import { Injectable } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { AlertController } from '@ionic/angular';

enum BallChangePolicyType {
    GAME = 'GAMES',
    SET = 'SET'
}

@Injectable({ providedIn: 'root' })

export class BallChangeService {

    constructor(
        private bhs: BoardHelpService,
        private alertController: AlertController
    ) { }

    async getBallChangeStatus(match: Match): Promise<{ count: number, type: string }> {
        const ballChangePolicyExtension = match.extensions.find(ext => ext.name === 'ballChangePolicy');

        if (!ballChangePolicyExtension || !ballChangePolicyExtension.value) return null;

        const ballChangePolicy = ballChangePolicyExtension.value;

        let numberOfUnitsBeforeBallChange = 0;

        if (match.matchStatus === 'TBP') {
            numberOfUnitsBeforeBallChange = ballChangePolicy.frequency[0];
        } else {
            if (ballChangePolicy.type === 'GAME') {
                let index: number;
                const numberOfGamesPlayed = this.getNumberOfGamesPlayed(match);

                if (numberOfGamesPlayed - 1 < ballChangePolicy.frequency[0]) {
                    numberOfUnitsBeforeBallChange = ballChangePolicy.frequency[0] - (numberOfGamesPlayed - 1) % ballChangePolicy.frequency[0];
                    index = 0;
                } else {
                    numberOfUnitsBeforeBallChange = ballChangePolicy.frequency[1] - (numberOfGamesPlayed - ballChangePolicy.frequency[0] - 1) % ballChangePolicy.frequency[1];
                    index = 1;
                }

                const findIndex = ballChangePolicy.frequency.findIndex(f => f === numberOfUnitsBeforeBallChange);

                if (findIndex > -1 && numberOfUnitsBeforeBallChange === ballChangePolicy.frequency[index]) {
                    if (this.bhs.getLastGame(match).points.length === 1 && !(match.sets.length === 1 && match.sets[0].games.length === 1)) {
                        await this.showChangeBallAlert();
                        numberOfUnitsBeforeBallChange = 0;
                    } else {
                        numberOfUnitsBeforeBallChange = ballChangePolicy.frequency[index];
                    }
                }
            } else if (ballChangePolicy.type === 'SET') {
                const numberOfSetsPlayed = match.sets.length;
                const changeBallFrequency = ballChangePolicy.frequency[0];

                if (changeBallFrequency === 1) {
                    if (this.bhs.getLastGame(match).points.length === 1 && match.sets.length > 1 && match.sets[match.sets.length - 1].games.length === 1) {
                        await this.showChangeBallAlert();
                        numberOfUnitsBeforeBallChange = 0;
                    } else if (match.sets.length === 3) {
                        numberOfUnitsBeforeBallChange = -1;
                    } else {
                        numberOfUnitsBeforeBallChange = 1;
                    }

                } else if (changeBallFrequency === 2) {
                    if (this.bhs.getLastGame(match).points.length === 1 && match.sets.length === 3 && match.sets[2].games.length === 1) {
                        await this.showChangeBallAlert();
                        numberOfUnitsBeforeBallChange = 0;
                    } else {
                        numberOfUnitsBeforeBallChange = changeBallFrequency - numberOfSetsPlayed + 1;
                    }
                }
            }
        }

        const ballChange = {
            count: numberOfUnitsBeforeBallChange,
            type: ballChangePolicy.type
        };

        return ballChange;
    }

    getNumberOfGamesPlayed(match: Match) {
        let numberOfGamesPlayed = 0;
        match.sets.forEach(set => {
            numberOfGamesPlayed += set.games.length;
        });

        return numberOfGamesPlayed;
    }

    async showChangeBallAlert() {
        const alert = await this.alertController.create({
            header: 'Ball Change',
            message: 'The balls should be replaced now',
            backdropDismiss: false,
            buttons: ['OK']
        });

        await alert.present();
    }
}
